import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserServices } from '../services/user.service'; // Ajusta según tu estructura

@Injectable({
  providedIn: 'root'
})
export class PublisherGuard implements CanActivate {
  
  constructor(private _userAPI: UserServices, private router: Router) {}
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    const userType = this._userAPI.sharedUser ? this._userAPI.sharedUser.type : undefined;
    
    if (userType === 'publisher' || userType === 'both') {
      return true;
    }
    
    this.router.navigate([next.parent.pathFromRoot[1].params['language'] + '/dashboard']);
    return false;
  }
}